import { render } from "./CustomerSectionGeneral.vue?vue&type=template&id=3c3e9084&scoped=true"
import script from "./CustomerSectionGeneral.vue?vue&type=script&lang=js"
export * from "./CustomerSectionGeneral.vue?vue&type=script&lang=js"

import "./CustomerSectionGeneral.vue?vue&type=style&index=0&id=3c3e9084&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3e9084"]])

export default __exports__